import React, { Component } from 'react';

import { Dropzone } from 'components/dropzone';
import { NoImg } from 'components/svg/images';
import { I18n } from 'components/translate';
import isEqual from 'lodash/isEqual';
import { ENTITY_TYPE } from 'modules/file/constants';
import PropTypes from 'prop-types';

import BoxImageUploadActions from './BoxImageUploadActions';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

import './BoxImageUpload.scss';
import './BoxMultipleImagesUpload.scss';

@UploadConsumer(ENTITY_TYPE.MEMBERSHIP_BACKGRD_AUDIO_VIDEO)
export default class BoxMultipleImagesUpload extends Component {
  // #region setup
  static propTypes = {
    placeholderImg: PropTypes.func,
    value: PropTypes.object,
    fileUpload: UploadProptypes.fileUpload,
    sendFiles: PropTypes.func,
    nMaxImages: PropTypes.func
  };

  static defaultProps = {
    value: [],
    nMaxImages: 4
  };

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps.value, this.props.value);
  }
  // #endregion

  get fileUpload() {
    return this.props.fileUpload;
  }

  get images() {
    const { value } = this.props;
    const orderedImages = value.sort((a, b) => a.fileOrder - b.fileOrder);

    return orderedImages;
  }

  renderImage(image, index) {
    const { ...props } = this.props;

    return (
      <div
        key={image.id}
        className="dropzone__internal dropzone__internal--with-media"
      >
        <BoxImageUploadActions
          full
          image={image}
          key={`boxMultipleImages_${index}`}
          canReplace={false}
          crop
          {...props}
        />
      </div>
    );
  }

  renderUploadZone() {
    return (
      <div className="dropzone__action__button">
        <NoImg key="dropzone__action__button__img" />

        <span className="secondary" key="dropzone__action__button__label">
          <I18n label="files.tabs.send_images" />
        </span>
      </div>
    );
  }

  hideDropZone() {
    const { value, nMaxImages } = this.props;

    return value.length === nMaxImages;
  }

  render() {
    const { placeholderImg: PlaceholderImg } = this.props;
    let classDropzone = null;
    let action = this.fileUpload && this.fileUpload.actions.sendMultiples;
    const Wrapper = Dropzone;
    let disabled = false;

    if (this.hideDropZone()) {
      classDropzone = 'dropzone--hidden';
      action = null;
      disabled = true;
    }

    return (
      <div className="box__image__upload dropzone box__image__upload--with-media">
        <div className="dropzone__info dropzone__info--large">
          {PlaceholderImg && (
            <div className="dropzone__info__placeholder">
              <PlaceholderImg />
            </div>
          )}

          <Wrapper
            onDrop={action}
            className={classDropzone}
            disabled={disabled}
          >
            {this.renderUploadZone()}
          </Wrapper>

          <div className="dropzone__images_area">
            {this.images.map((element, index) =>
              this.renderImage(element, index)
            )}
          </div>
        </div>
      </div>
    );
  }
}
